<template>
  <div>
    <div class="row mb-5">
      <div class="col-12">
        <div class="nature-white-box">
          <div class="white-box-top"></div>
          <div class="row">
            <TopBar
              v-model:selectAll="selectAll"
              v-model:line-options="lineOptions"
              v-model:rows="rows"
              v-model:items="items"
              v-model:selectedLineOption="selectedLineOption"
              v-model:selectedItems="selectedItems"
              v-on:addNewRow="addNewOutgoing"
              v-on:delete="cancelOperations"
              :show-delete="true"
              :show-select="false"
              :show-currencies="false"
              :show-languages="false"
              :export-url="getUrl(true)"
            />
            <DynamicTable
              v-model:rows="rows"
              v-model:items="items"
              v-model:select-all="selectAll"
              v-on:selected="(e) => (selectedItems = e)"
              type="products"
              :key="tableKey"
              :show-pin="false"
              :show-order="false"
              :show-select="true"
              :fix-height="true"
              v-on:loadMore="loadMore"
            />
          </div>
        </div>
      </div>
    </div>
    <NewOutgoing v-model:show="addNew" v-on:newItem="newItem" />
    <ConfirmModal
      ref="noWarehouseModal"
      :title="$t(`outgoing.noWarehouseSelected`)"
      text="please select a warehouse before adding a new transfer!"
      :show-ok="false"
      cancel-button="Ok"
    />
  </div>
</template>

<script>
import TopBar from "../../components/lists/TopBar";
import DynamicTable from "../../components/lists/DynamicTable";
import NewOutgoing from "../../components/modals/NewOutgoing";
import ConfirmModal from "../../components/modals/ConfirmModal";
import { useStore } from "vuex";
import http from "../../modules/http";
import lineOptions from "../../modules/lineOptions";
import incomingstatuses from "../../modules/Incomingstatuses";

export default {
  name: "Outgoing",
  components: { ConfirmModal, NewOutgoing, DynamicTable, TopBar },
  data() {
    return {
      store: useStore(),
      tableKey: 0,
      addNew: false,
      rows: [],
      selectedItems: [],
      selectedLineOption: 1,
      lineOptions: [],
      selectAll: false,
      items: [],
      partners: [],
      filtersTimeOut: null,
      firstLoad: true,
      page: 1,
    };
  },
  computed: {
    warehouse() {
      return this.store.state.topBar.warehouse;
    },
    warehouses() {
      return this.store.state.warehouses;
    },
    date() {
      return this.store.state.topBar.date;
    },
    q() {
      return this.store.state.topBar.q;
    },
    filterPage() {
      return this.store.state.filterPage;
    },
    filters() {
      return this.store.state.filters?.outgoings;
    },
  },
  watch: {
    warehouse() {
      this.loadData();
    },
    q() {
      if (this.filtersTimeOut !== null) {
        clearTimeout(this.filtersTimeOut);
      }
      this.filtersTimeOut = setTimeout(() => {
        this.filtersTimeOut = null;
        this.page = 1;
        this.loadData();
      }, 450);
    },
    filters: {
      deep: true,
      handler() {
        if (this.filterPage !== "outgoings" || this.firstLoad) {
          setTimeout(() => {
            this.firstLoad = false;
          }, 100);
          return;
        }
        if (this.filtersTimeOut !== null) {
          clearTimeout(this.filtersTimeOut);
        }
        this.filtersTimeOut = setTimeout(() => {
          this.filtersTimeOut = null;
          this.page = 1;
          this.loadData();
        }, 450);
      },
    },
    date: {
      deep: true,
      handler() {
        this.loadData();
      },
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    getUrl(exports = false) {
      let url =
        `/warehouses/outgoing${exports ? "/export/{type}" : ""}?page=${
          exports ? 1 : this.page
        }` +
        (this.warehouse ? "&warehouse=" + this.warehouse : "") +
        (this.q ? "&q=" + this.q : "") +
        (this.date[0]
          ? "&from=" + this.date[0].toISOString().split("T")[0]
          : "") +
        (this.date[1] ? "&to=" + this.date[1].toISOString().split("T")[0] : "");

      if (this.filterPage !== "outgoings") {
        url += `&status[]=-3&status[]=-2&status[]=-1&status[]=0&status[]=1&status[]=2&status[]=3&status[]=4&status[]=5`;
      } else if (Object.keys(this.filters)?.length > 0) {
        for (const filter in this.filters) {
          if (Array.isArray(this.filters[filter].value)) {
            for (const value of this.filters[filter].value) {
              url += `&${filter}[]=${value}`;
            }
          } else {
            url += `&${filter}=${this.filters[filter].value}`;
          }
        }
      }

      return url;
    },
    setFilterOptions() {
      if (this.filterPage !== "outgoings") {
        this.$store.commit("setFilterOptions", []);

        http
          .fetch("/products/products/characteristics?language=en")
          .then((data) => {
            let filterOptions = [];
            this.$store.commit("setFilterPage", "outgoings");

            filterOptions.push({
              name: "Status",
              type: "string",
              key: "status",
              value: {
                "-3": true,
                "-2": true,
                "-1": true,
                0: true,
                1: true,
                2: true,
                3: true,
                4: true,
                5: true,
              },
              values: Object.values(incomingstatuses),
              valueName: "name",
            });

            this.filters["status"] = {
              value: ["-3", "-2", "-1", 0, 1, 2, 3, 4, 5],
            };

            filterOptions.push({
              name: "Categories",
              type: "string",
              key: "categories",
              value: {},
              values: this.categories,
              valueName: "name",
            });

            filterOptions.push({
              name: "Partners",
              type: "string",
              key: "partners",
              value: {},
              values: this.partners,
              valueName: "name",
            });

            for (const obj of data) {
              let max =
                obj.characteristics_values_max_val_double !== null
                  ? obj.characteristics_values_max_val_double
                  : obj.characteristics_values_max_val_int;
              filterOptions.push({
                name: obj.name,
                type: obj.type,
                key: "characteristics[" + obj.id + "]",
                value: obj.type === "number" ? [0, max] : {},
                max: max,
                values: obj?.characteristics_values,
                prefix: obj?.prefix,
                postfix: obj?.postfix,
              });
            }

            this.$store.commit("setFilterOptions", filterOptions);
            this.$store.commit("setFilterOptionsStock", false);
            this.$store.commit("setFilterOptionsPrice", false);
          });
      }
    },
    loadData() {
      if (this.page === 1) {
        this.items = null;
        if (this.partners.length === 0) {
          http.fetch("/crm/partners/has-income").then((data) => {
            this.partners = data;
            this.setFilterOptions();
          });
        } else {
          this.setFilterOptions();
        }
      }
      http.fetch(this.getUrl()).then((data) => {
        if (this.page === 1) {
          this.rows = lineOptions.init(data.rows, data.line_options);
          this.lineOptions = data.line_options;
          this.selectedLineOption = data.line_options[0].id;

          this.rows.find((e) => e.key === "warehouse_outcome_id").values =
            this.warehouses;

          let status = this.rows.find((e) => e.key === "status");
          status.values = incomingstatuses;
          status.center = true;

          this.items = data.data;
          this.tableKey++;
        } else {
          for (const row of data.data) {
            this.items.push(row);
          }
        }
      });
    },
    loadMore() {
      this.page++;
      this.loadData();
    },
    addNewOutgoing() {
      if (this.warehouse === null) {
        this.$refs.noWarehouseModal.showModal();
      } else {
        this.addNew = true;
      }
    },
    newItem(data) {
      this.items.unshift(data);
      this.tableKey++;
    },
    cancelOperations() {
      let data = [];
      for (const item of this.selectedItems) {
        data.push(item.id);
      }
      http.fetch(`/warehouses/income/cancel`, { rows: data }, true).then(() => {
        for (const item of this.selectedItems) {
          let i = this.items.indexOf(item);
          if (i > -1) {
            this.items[i].status = 7;
          }
        }
        this.tableKey++;
      });
    },
  },
};
</script>
